const documentList = document.querySelector('.document-list');

if (documentList) {
  const modalTitle = documentList.querySelector('.modal__header .title');
  const modalInput = documentList.querySelector('.modal__file-path-input');
  const modalForm = documentList.querySelector('form#order_form');

  attachEvent('.document-list__item-button', 'click', (event) => {
    const parent = event.target.closest('.document-list__item');
    if (!parent) return;

    const title = parent.querySelector('.document-list__item-title');
    if (!title) return;

    const filePath = title.getAttribute('href');
    modalInput.value = filePath;
    modalTitle.textContent = title.textContent;
    modalTitle.textContent = title.textContent;

    if (modalForm) {
      let hiddenInput = modalForm.querySelector('input[name="file-path"]');

      if (!hiddenInput) {
        hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'file-path';
        hiddenInput.id = 'file-path';
        hiddenInput.setAttribute('data-fv-name', 'file-path');
        modalForm.appendChild(hiddenInput);
      }

      hiddenInput.value = filePath;
    }
  });
}
